import React from 'react';

export const defaultValue = {
  projectName: '필기 분석'
};
export const AppContext = React.createContext(defaultValue);
